import store from 'store2';
import { IAdminOnboardingStep, OnboardingStepStatus } from './types';

const onboardingStore = store.namespace('onboarding');

/** Clean up `localStorage` items related to onboarding. */
export const cleanupOnboardingStore = () => {
  onboardingStore.clearAll();
};

/** Returns `true` if the user has seen the confetti. */
export const getHasViewedConfetti = () =>
  onboardingStore.get('hasViewedConfetti') ?? false;

/** Store the fact that the user has viewed the confetti in `localStorage`. */
export const setHasViewedConfetti = () => {
  onboardingStore.set('hasViewedConfetti', true);
};

/** Returns `true` if the specified onboarding step is complete. */
export const isOnboardingStepComplete = (
  onboardingStep: IAdminOnboardingStep
) => onboardingStep?.status === OnboardingStepStatus.COMPLETED;
